import React from 'react'
import { AppSvg, FormattedHTMLMessage, icons, Button } from '@web/walter-ui-kit'

import styles from '../../style.module.css'
import { lang } from './lang'
import { useModal } from '~contexts/ModalsContext'
import ModalView from '~components/ModalView'
import { ModalTypes } from '~contexts/ModalsContext/types'

function Success() {
    const { hide } = useModal(ModalTypes.migration)

    return (
        <ModalView
            img={
                <div className={styles.waitIcon}>
                    <AppSvg size={60} svgName={icons.ic60RoundArrow} />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.migrationStartedTitle} />}
            subtitle={<FormattedHTMLMessage {...lang.migrationStartedSubtitle} />}
        >
            <Button size="l" onClick={hide} mode="primary" dataPointer="ok_button">
                <FormattedHTMLMessage {...lang.migrationStartedButtonText} />
            </Button>
        </ModalView>
    )
}

export default Success
